(function () {
  if (window.__memilonReveal) return;
  window.__memilonReveal = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';

  function prime(el) {
    if (el.__mrPrimed) return;
    el.__mrPrimed = true;
    if (reduce) { el.style.opacity = '1'; return; }
    var d = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
    el.style.opacity = '0';
    el.style.transform = 'translateY(18px)';
    el.style.transition = 'opacity .7s ' + EASE + ' ' + d + 'ms, transform .7s ' + EASE + ' ' + d + 'ms';
    el.style.willChange = 'opacity, transform';
  }
  function show(el) { el.style.opacity = '1'; el.style.transform = 'none'; }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }) : null;

  function scan() {
    var els = document.querySelectorAll('[data-reveal]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__mrSeen) continue;
      el.__mrSeen = true;
      prime(el);
      if (!io || reduce) { show(el); continue; }
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95) { requestAnimationFrame(function (n) { return function () { show(n); }; }(el)); }
      else io.observe(el);
    }
  }

  var t = null;
  function queue() { clearTimeout(t); t = setTimeout(function () { scan(); markLifts(); }, 60); }
  if (document.readyState !== 'loading') queue();
  document.addEventListener('DOMContentLoaded', queue);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });

  var base = [
    'html{scroll-behavior:' + (reduce ? 'auto' : 'smooth') + '}',
    '[id]{scroll-margin-top:130px}',
    'a:focus-visible,button:focus-visible,input:focus-visible,textarea:focus-visible,select:focus-visible,[tabindex]:focus-visible{outline:2px solid var(--action-primary);outline-offset:3px;border-radius:4px}',
    'a:focus:not(:focus-visible),button:focus:not(:focus-visible){outline:none}',
    '::selection{background:var(--c-sage);color:var(--c-ink)}',
    '#mem-skip{position:fixed;top:-100px;left:16px;z-index:900;background:var(--c-forest);color:#F4F1E6;font-family:var(--font-ui);font-weight:700;font-size:14px;padding:13px 22px;border-radius:999px;text-decoration:none;box-shadow:0 8px 24px rgba(29,33,31,.22);transition:top .25s ' + EASE + '}',
    '#mem-skip:focus{top:16px;color:#F4F1E6}',
    '#mem-progress{position:fixed;top:0;left:0;height:2px;width:0;background:var(--action-primary);z-index:900;pointer-events:none;transition:width .1s linear,opacity .3s ease;opacity:0}',
    '#mem-top{position:fixed;right:20px;bottom:20px;z-index:400;width:46px;height:46px;border-radius:50%;border:1px solid var(--border-subtle);background:var(--surface-card);color:var(--text-primary);cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 8px 24px rgba(29,33,31,.14);opacity:0;visibility:hidden;transform:translateY(10px);transition:opacity .3s ease,transform .3s ' + EASE + ',visibility .3s}',
    '#mem-top[data-on]{opacity:1;visibility:visible;transform:none}',
    '#mem-top:hover{background:var(--action-primary);color:#F4F1E6;border-color:var(--action-primary)}',
    '@media (max-width:900px){header a,header button{min-height:44px}}'
  ];

  var motion = reduce ? [] : [
    '@keyframes mem-fade-in{from{opacity:0}to{opacity:1}}',
    '@keyframes mem-drop-in{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}',
    '@keyframes mem-panel-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
    '[data-lift]{transition:box-shadow .3s ' + EASE + ',transform .3s ' + EASE + '}',
    '[data-lift]:hover{transform:translateY(-3px);box-shadow:0 16px 36px rgba(29,33,31,.13)}',
    '[data-lift] .mem-img{transition:transform .55s ' + EASE + '}',
    '[data-lift]:hover .mem-img:not(.mem-img--contain){transform:scale(1.06)}',
    '[data-cta]{text-decoration:none;transition:text-decoration-color .22s ease}',
    '[data-cta]:hover{text-decoration:underline}',
    'a{transition:color .22s ease,opacity .22s ease}',
    'button,[class*="Button"]{transition:background-color .22s ease,color .22s ease,border-color .22s ease,opacity .22s ease,transform .22s ' + EASE + '}',
    'button:active,.mem-btn:active{transform:translateY(1px)}',
    'input,textarea{transition:border-color .22s ease,background-color .22s ease}',
    'input:focus,textarea:focus{border-color:var(--action-primary)}',
    '.mem-img{animation:mem-fade-in .5s ease both}',
    '[data-panel]{animation:mem-panel-in .34s ' + EASE + ' both}'
  ];

  var st = document.createElement('style');
  st.id = 'memilon-motion';
  st.textContent = base.concat(motion).join('\n');
  (document.head || document.documentElement).appendChild(st);

  function mount() {
    if (!document.body || document.getElementById('mem-skip')) return;
    var skip = document.createElement('a');
    skip.id = 'mem-skip';
    skip.href = '#mem-main';
    skip.addEventListener('click', function () {
      var s = document.querySelector('main section');
      if (s) setTimeout(function () { s.focus({ preventScroll: true }); }, 400);
    });
    skip.textContent = document.documentElement.lang === 'de' ? 'Zum Inhalt springen' : 'Skip to main content';
    document.body.insertBefore(skip, document.body.firstChild);

    var bar = document.createElement('div');
    bar.id = 'mem-progress';
    document.body.appendChild(bar);

    var top = document.createElement('button');
    top.id = 'mem-top';
    top.type = 'button';
    top.setAttribute('aria-label', document.documentElement.lang === 'de' ? 'Nach oben' : 'Back to top');
    top.innerHTML = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 19V6"></path><path d="M6 12l6-6 6 6"></path></svg>';
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    document.body.appendChild(top);

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || document.documentElement.scrollTop;
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var pct = h > 0 ? Math.min(1, y / h) : 0;
        bar.style.width = (pct * 100) + '%';
        bar.style.opacity = y > 80 ? '1' : '0';
        if (y > 900) top.setAttribute('data-on', ''); else top.removeAttribute('data-on');
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function landmark() {
    var skip = document.getElementById('mem-skip');
    if (!skip) return;
    var s = document.querySelector('main section');
    if (!s) return;
    if (!s.id) s.id = 'mem-main';
    s.setAttribute('tabindex', '-1');
    skip.setAttribute('href', '#' + s.id);
  }

  function markLifts() {
    var els = document.querySelectorAll('a[style*="box-shadow:var(--shadow-card)"],a[style*="box-shadow: var(--shadow-card)"]');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].hasAttribute('data-lift')) els[i].setAttribute('data-lift', '');
    }
  }

  if (document.readyState !== 'loading') { mount(); landmark(); }
  document.addEventListener('DOMContentLoaded', function () { mount(); landmark(); });
  var lt = null;
  new MutationObserver(function () {
    clearTimeout(lt); lt = setTimeout(function () { mount(); landmark(); markLifts(); }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
